import { useState } from 'react';
import configUrl from '../config'

const useAuth = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [storeInfo, setStoreInfo] = useState(null);

  const login = async (userInfo) => {
    try {
      const response = await fetch(configUrl.apiUrl + '/api/auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          store_id: userInfo.loginId,
          password: userInfo.password
        })
      });

      const result = await response.json();

      if (result.success) {
        // API 응답에서 받은 실제 매장 정보 사용
        const storeData = {
          id: result.data.store_info.id,
          name: result.data.store_info.name,
          phone: result.data.store_info.phone,
          address: result.data.store_info.address,
          owner_id: result.data.store_info.owner_id,
          owner_name: result.data.store_info.owner_name,
          owner_phone: result.data.store_info.owner_phone,
          is_owner: result.data.store_info.is_owner,
          card_info: JSON.parse(result.data.store_info.card_info),
          is_active: result.data.store_info.is_active,
          start_date: result.data.store_info.start_date,
          start_date_code: result.data.store_info.start_date_code,
          // 기존 프로퍼티들도 호환성을 위해 유지
          storeName: result.data.store_info.name,
          storeCode: result.data.store_info.id,
          loginId: result.data.store_info.owner_id,
          stampRule: result.data.store_info.card_info ? JSON.parse(result.data.store_info.card_info).stampPositions?.[0] || 10 : 10
        };
        
        setStoreInfo(storeData);
        setIsLoggedIn(true);

        // 로컬 스토리지에 저장
        localStorage.setItem('isLoggedIn', 'true');
        localStorage.setItem('storeInfo', JSON.stringify(storeData));
        localStorage.setItem('token', result.data.token);

        return { success: true };
      } else {
        return { 
          success: false, 
          error: result.error || '로그인에 실패했습니다.' 
        };
      }
    } catch (error) {
      return { 
        success: false, 
        error: '네트워크 오류가 발생했습니다.' 
      };
    }
  };

  const logout = () => {
    setIsLoggedIn(false);
    setStoreInfo(null);
    
    // 로컬 스토리지에서 제거
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('storeInfo');
    localStorage.removeItem('token');
  };

  const updateStoreInfo = (newInfo) => {
    const updatedInfo = { ...storeInfo, ...newInfo };
    setStoreInfo(updatedInfo);
    localStorage.setItem('storeInfo', JSON.stringify(updatedInfo));
  };

  // 페이지 새로고침 시 로그인 상태 복원
  const checkAuthStatus = () => {
    const savedLoginStatus = localStorage.getItem('isLoggedIn');
    const savedStoreInfo = localStorage.getItem('storeInfo');
    
    if (savedLoginStatus === 'true' && savedStoreInfo) {
      setIsLoggedIn(true);
      setStoreInfo(JSON.parse(savedStoreInfo));
    }
  };

  return {
    isLoggedIn,
    storeInfo,
    login,
    logout,
    updateStoreInfo,
    checkAuthStatus
  };
};

export default useAuth;